// @generated by scripts/gen-modules.mjs
import { lazy } from 'react';
import { RouteObject, Navigate } from 'react-router-dom';
import { ModuleGuard } from '@shared/module-kit';

const EssLeavePage = lazy(() => import('./pages/EssLeavePage'));
const EssPayslipsPage = lazy(() => import('./pages/EssPayslipsPage'));
const EssProfilePage = lazy(() => import('./pages/EssProfilePage'));
const BenefitsPage = lazy(() => import('./pages/BenefitsPage'));
const EssDocumentsPage = lazy(() => import('./pages/EssDocumentsPage'));

export const SelfserviceRoutes: RouteObject = {
  path: 'selfservice',
  element: <ModuleGuard moduleId="people.selfservice" />,
  handle: { crumb: 'Employee Self-Service' },
  children: [
    { index: true, element: <Navigate to="ess-leave" replace /> },
    { path: 'ess-leave', element: <EssLeavePage />, handle: { crumb: 'My Leave' } },
    { path: 'ess-payslips', element: <EssPayslipsPage />, handle: { crumb: 'My Payslips' } },
    { path: 'ess-profile', element: <EssProfilePage />, handle: { crumb: 'My Profile' } },
    { path: 'benefits', element: <BenefitsPage />, handle: { crumb: 'Benefits' } },
    { path: 'ess-documents', element: <EssDocumentsPage />, handle: { crumb: 'My Documents' } },
  ],
};
